module.exports = __webpack_public_path__ + "img/jd.6922a6f3.svg";